<template>
  <div class="el-loading-mask is-fullscreen">
      <div class="el-loading-spinner">
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 1024 1024" width="100" height="100">
      <path
        d="M511.573 0.853
              C233.067 0.853 6.55 223.445 0.15 500.416 6.06 258.731 189.824 64.811 415.66 64.811
              c229.546 0 415.658 200.426 415.658 447.616 0 52.97 42.944 95.936 95.915 95.936 52.95 0 95.915-42.966 95.915-95.936
              C1023.147 229.888 794.112 0.853 511.573 0.853z 
              m0 1023.147
              c278.507 0 505.024-222.592 511.403-499.563-5.888 241.664-189.653 435.627-415.488 435.627-229.547 0-415.659-200.448-415.659-447.637 0-52.95-42.965-95.915-95.936-95.915
              C42.965 416.512 0 459.456 0 512.427 0 794.965 229.035 1024 511.573 1024z"
        p-id="9153" fill="#409eff"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0 512 512"
          to="360 512 512"
          begin="0s"
          dur="3s"
          repeatCount="indefinite"
        />
      </path>
      <text id="time" x="280" y="600" font-size="200" fill="#409eff">300</text>
      <text x="680" y="600" font-size="200" fill="#409eff">s</text>
    </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "Source",
  props: {
    visible: {
      type: Boolean
    }
  },
  data() {
    return {
      timer: ""
    };
  },

  mounted() {
    let textnode, text;
    this.timer = setInterval(function() {
      textnode = document.getElementById("time");
      text = Number(textnode.textContent);
      if (text > 0) {
        text--;
        textnode.textContent = text;
      } else {
        textnode.textContent = 300;
      }
    }, 1000);
  },
  methods: {
    cancel() {
      clearInterval(this.timer);
      this.$emit("clearTime");
    }
  }
};
</script>
<style scoped>

</style>
